module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "integrationCard d-flex flex-column border-light radius-10 shadow-10"
  }, [_c('div', {
    staticClass: "logoHolder d-flex align-items-center justify-content-center radius-top-left-10 radius-top-right-10",
    style: ({
      'background-color': _vm.integration.color.main
    })
  }, [(_vm.warning().level > 0) ? _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.warning().message),
      expression: "warning().message"
    }],
    staticClass: "warningSign fas fa-exclamation-triangle color-5",
    class: {
      'color-6': _vm.warning().level == 2
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showSettingsCog(_vm.integration)) ? _c('i', {
    staticClass: "settingsIcon fas fa-cog lightest opacity-50 pointer",
    on: {
      "click": function($event) {
        return _vm.openIntegrationSettings(_vm.integration)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.integration.logo) ? _c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.integration.logo.white,
      "alt": ""
    }
  }) : _c('div', {
    staticClass: "fs-large lightest bold"
  }, [_vm._v("\n            " + _vm._s(_vm.integration.label) + "\n        ")]), _vm._v(" "), (_vm.showStatus(_vm.integration)) ? _c('span', {
    staticClass: "status px-2 py-0 radius-normal fs-smaller bold",
    class: ['bg-' + _vm.status(_vm.integration.integrationStatus).backgroundColor, _vm.status(_vm.integration.integrationStatus).textColor]
  }, [_vm._v("\n            " + _vm._s(_vm.status(_vm.integration.integrationStatus).label) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "p-2 d-flex flex-column flex-grow-1"
  }, [_c('div', {
    staticClass: "fs-small descriptionHolder flex-grow-1 my-1"
  }, [_vm._v("\n            " + _vm._s(_vm.integration.descriptionSmall) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [(_vm.getIsLoadingSupplierIntegrations) ? _c('div', {
    staticClass: "text-center"
  }, [_c('loader')], 1) : (_vm.integration.comingSoon && _vm.integration.comingSoon == true) ? _c('button', {
    staticClass: "btn blue w-100",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openIntegration(_vm.integration)
      }
    }
  }, [_vm._v("Details")]) : ((_vm.integration.integrationStatus == 0 || _vm.integration.integrationStatus == 4) && !_vm.integration.showView) ? _c('button', {
    staticClass: "btn green w-100",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openIntegration(_vm.integration)
      }
    }
  }, [_vm._v("Connect")]) : _c('button', {
    staticClass: "btn tertiary w-100",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openIntegration(_vm.integration)
      }
    }
  }, [_vm._v("View")])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-25976bb5", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25976bb5"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/integrations/components/IntegrationCard.vue
// module id = 2538
// module chunks = 0